<template>
  <label
    class="block mb-2 xl:text-sm font-normal"
    :for="name"
    v-text="label"
  />
</template>

<script>
export default {
  name: 'InputLabel',

  props: {
    label: {
      required: true,
      type: String,
    },
    name: {
      required: true,
      type: String,
    },
  },
};
</script>
